import { useBreakpoint, type BreakpointName } from '@chakra-ui/react';

type ObtBreakpointRange = 'xlTo2xl';
type ObtBreakpointKey = BreakpointName | ObtBreakpointRange;
type ObtBreakpointValues<T> = Partial<Record<ObtBreakpointKey, T>>;

const breakpointOrder: BreakpointName[] = ['base', 'sm', 'md', 'lg', 'xl', '2xl', 'full'];

export function useObtBreakpointValue<T>(values: ObtBreakpointValues<T>): T | undefined {
  const breakpoint = useBreakpoint({
    breakpoints: breakpointOrder,
    fallback: 'base'
  }) as BreakpointName;

  for (const key of getResolutionKeys(breakpoint)) {
    if (Object.hasOwn(values, key)) {
      return values[key];
    }
  }

  return undefined;
}

function getResolutionKeys(breakpoint: BreakpointName): ObtBreakpointKey[] {
  const index = breakpointOrder.indexOf(breakpoint);

  if (index < 0) {
    return ['base'];
  }

  const lowerBreakpoints = breakpointOrder.slice(0, index).reverse();

  if (breakpoint === 'xl') {
    return [breakpoint, 'xlTo2xl', ...lowerBreakpoints];
  }

  return [breakpoint, ...lowerBreakpoints];
}
